"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actions = exports.types = void 0;
exports.types = {
    SHOW_IN_PAGE_ERROR: 'ERRORCATCHER/SHOW_IN_PAGE_ERROR',
    CLEAR_IN_PAGE_ERROR: 'ERRORCATCHER/CLEAR_IN_PAGE_ERROR',
};
const initialState = {
    inPageError: null,
};
const ErrorCatcherReducer = (state = initialState, action) => {
    switch (action.type) {
        case exports.types.SHOW_IN_PAGE_ERROR: {
            if (action.payload) {
                return Object.assign(Object.assign({}, state), { inPageError: action.payload });
            }
            return state;
        }
        case exports.types.CLEAR_IN_PAGE_ERROR: {
            return Object.assign({}, initialState);
        }
        default:
            return state;
    }
};
exports.actions = {
    showInPageError: (args) => ({
        type: exports.types.SHOW_IN_PAGE_ERROR,
        payload: args,
    }),
    clearInPageError: (location) => ({
        type: exports.types.CLEAR_IN_PAGE_ERROR,
        location,
    }),
};
exports.default = ErrorCatcherReducer;
//# sourceMappingURL=errorCatcher.js.map